import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import { list as industryList } from "../../../services/industry";
import { list as skillList } from "../../../services/skill";
import { list as jobNicheList } from "../../../services/jobNiche";
import { list as badgeList } from "../../../services/badge";
import { list as scraperList } from "../../../services/scraper";
import { list as countryList } from "../../../services/country";
import {filterAll} from "../../../services/writer";
import Select from "react-select";
class FilterModel extends Component {
    constructor(props) {
        super(props);
        this.selectIndustryRef          = React.createRef();
        this.selectTopicRef             = React.createRef();
        this.selectSkillRef             = React.createRef();
        this.selectBadgeRef             = React.createRef();
        this.selectPublicationRef       = React.createRef();
        this.selectLocationRef          = React.createRef();
        this.selectVerifiedStatusRef    = React.createRef();
        this.selectVerifcationStatusRef = React.createRef();
        this.selectTypeRef              = React.createRef();
    }

    state = {
        industryList: [],
        topicList: [],
        skillList: [],
        badgeList: [],
        scraperList: [],
        countryList: [],
        verifiationStatusList: [
            {
                id: '1',
                name: 'Applied',
                label: 'Pending',
                value: 'applied'
            },
            {
                id: '2',
                name: 'Approved',
                label: 'Approved',
                value: 'approved'
            },
            {
                id: '3',
                name: 'Declined',
                label: 'Declined',
                value: 'rejected'
            },
            {
                id: '4',
                name: 'Re-review',
                label: 'Re-review',
                value: 'review'
            },
            {
                id: '5',
                name: 'Completed',
                label: 'Applied',
                value: 'completed'
            },
            {
                id: '6',
                name: 'Failed',
                label: 'Failed',
                value: 'failed'
            }
        ],
        verifiedList: [
            {
                id: '1',
                name: 'Yes',
                label: 'Yes',
                value: 'true'
            },
            {
                id: '2',
                name: 'No',
                label: 'No',
                value: 'false'
            }
        ],
        typeList: [
            {
                id: '1',
                name: 'Registered',
                label: 'Registered',
                value: 'internal'
            },
            {
                id: '2',
                name: 'Sourced',
                label: 'Sourced',
                value: 'external'
            }
        ],
        loading: false,
        clearFilterloading: false,
        industryInterests: [],
        topicInterests: [],
        skillInterests: [],
        badgeInterests: [],
        locationInterests: [],
        publicationInterests: [], 
        item : {
            selectedIndustry: [],
            selectedTopic: [],
            selectedSkill: [],
            selectedBadge: [],
            selectedLocation: [],
            selectedPublication: [],
            selectedVerified: [],
            selectedVerificationStatus: [],
            selectedType: [],
            selectedIndustryLength: 0
        }
    }

    

    handleIndustrySelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.selectedIndustry = [];
            selectedOption.forEach(function (item, index) {
                temp.selectedIndustry[index] = {};
                temp.selectedIndustry[index]['id'] = item.id;
                temp.selectedIndustry[index]['value'] = item.value;
                temp.selectedIndustry[index]['name'] = item.name;
                temp.selectedIndustry[index]['label'] = item.label;
            });
        } else {
            temp.selectedIndustry = [];
        }
        this.setState({ item: temp });
    }

    handleTopicSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.selectedTopic = [];
            selectedOption.forEach(function (item, index) {
                temp.selectedTopic[index] = {};
                temp.selectedTopic[index]['id'] = item.id;
                temp.selectedTopic[index]['value'] = item.value;
                temp.selectedTopic[index]['name'] = item.name;
                temp.selectedTopic[index]['label'] = item.label;
            });
        } else {
            temp.selectedTopic = [];
        }
        this.setState({ item: temp });
    }

    handleSkillSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.selectedSkill = [];
            selectedOption.forEach(function (item, index) {
                temp.selectedSkill[index] = {};
                temp.selectedSkill[index]['id'] = item.id;
                temp.selectedSkill[index]['value'] = item.value;
                temp.selectedSkill[index]['name'] = item.name;
                temp.selectedSkill[index]['label'] = item.label;
            });
        } else {
            temp.selectedSkill = [];
        }
        this.setState({ item: temp });
    }

    handleLocationSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.selectedLocation = [];
            selectedOption.forEach(function (item, index) {
                temp.selectedLocation[index] = {};
                temp.selectedLocation[index]['id'] = item.value;
                temp.selectedLocation[index]['value'] = item.value;
                temp.selectedLocation[index]['name'] = item.name;
                temp.selectedLocation[index]['label'] = item.label;
            });
        } else {
            temp.selectedLocation = [];
        }
        this.setState({ item: temp });
    }

    handlePublicationSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.selectedPublication = [];
            selectedOption.forEach(function (item, index) {
                temp.selectedPublication[index] = {};
                temp.selectedPublication[index]['id'] = item.id;
                temp.selectedPublication[index]['value'] = item.value;
                temp.selectedPublication[index]['name'] = item.name;
                temp.selectedPublication[index]['label'] = item.label;
            });
        } else {
            temp.selectedPublication = [];
        }
        this.setState({ item: temp });
    }

    handleBadgeSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.selectedBadge = [];
            selectedOption.forEach(function (item, index) {
                temp.selectedBadge[index] = {};
                temp.selectedBadge[index]['id'] = item.id;
                temp.selectedBadge[index]['value'] = item.value;
                temp.selectedBadge[index]['name'] = item.name;
                temp.selectedBadge[index]['label'] = item.label;
            });
        } else {
            temp.selectedBadge = [];
        }
        this.setState({ item: temp });
    }

    handleVerifiedSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.selectedVerified = [];
            selectedOption.forEach(function (item, index) {
                temp.selectedVerified[index] = {};
                temp.selectedVerified[index]['id'] = item.id;
                temp.selectedVerified[index]['value'] = item.value;
                temp.selectedVerified[index]['name'] = item.name;
                temp.selectedVerified[index]['label'] = item.label;
            });
        } else {
            temp.selectedVerified = [];
        }
        this.setState({ item: temp });
    }

    handleVerificationStatusSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.selectedVerificationStatus = [];
            selectedOption.forEach(function (item, index) {
                temp.selectedVerificationStatus[index] = {};
                temp.selectedVerificationStatus[index]['id'] = item.id;
                temp.selectedVerificationStatus[index]['value'] = item.value;
                temp.selectedVerificationStatus[index]['name'] = item.name;
                temp.selectedVerificationStatus[index]['label'] = item.label;
            });
        } else {
            temp.selectedVerificationStatus = [];
        }
        this.setState({ item: temp });
    }

    handleTypeSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.selectedType = [];
            selectedOption.forEach(function (item, index) {
                temp.selectedType[index] = {};
                temp.selectedType[index]['id'] = item.id;
                temp.selectedType[index]['value'] = item.value;
                temp.selectedType[index]['name'] = item.name;
                temp.selectedType[index]['label'] = item.label;
            });
        } else {
            temp.selectedType = [];
        }
        this.setState({ item: temp });
    }

    clearFilter = () => {
        this.setState({ clearFilterloading: true});
        this.selectIndustryRef.current.select.clearValue();
        this.selectTopicRef.current.select.clearValue();
        this.selectSkillRef.current.select.clearValue();
        this.selectBadgeRef.current.select.clearValue();
        this.selectPublicationRef.current.select.clearValue();
        this.selectLocationRef.current.select.clearValue();
        this.selectVerifiedStatusRef.current.select.clearValue();
        this.selectVerifcationStatusRef.current.select.clearValue();
        this.selectTypeRef.current.select.clearValue();
        this.setState({ clearFilterloading: false })
    }

    applyFilter = () => {
        this.setState({ loading: true });
        filterAll(this.state.item).then(response => {
            this.setState({ loading: false });
            this.props.getFilterData(response, this.state.item);
        }).then(res =>{
            this.props.hideFilter();
        });
    }

    componentDidMount() {
        let temp = this.state.item;

        if (this.props.selectedFilterData.selectedIndustry != undefined) {
            if (this.props.selectedFilterData.selectedIndustry.length > 0) {
                this.props.selectedFilterData.selectedIndustry.forEach(function (item, index) {
                    temp.selectedIndustry[index] = {};
                    temp.selectedIndustry[index]['id'] = item.id;
                    temp.selectedIndustry[index]['value'] = item.value;
                });
            }
        }

        if (this.props.selectedFilterData.selectedTopic != undefined) {
            if (this.props.selectedFilterData.selectedTopic.length > 0) {
                this.props.selectedFilterData.selectedTopic.forEach(function (item, index) {
                    temp.selectedTopic[index] = {};
                    temp.selectedTopic[index]['id'] = item.id;
                    temp.selectedTopic[index]['value'] = item.value;
                });
            }
        }

        if (this.props.selectedFilterData.selectedSkill != undefined) {
            if (this.props.selectedFilterData.selectedSkill.length > 0) {
                this.props.selectedFilterData.selectedSkill.forEach(function (item, index) {
                    temp.selectedSkill[index] = {};
                    temp.selectedSkill[index]['id'] = item.id;
                    temp.selectedSkill[index]['value'] = item.value;
                });
            }
        }
        if (this.props.selectedFilterData.selectedBadge != undefined) {
            if (this.props.selectedFilterData.selectedBadge.length > 0) {
                this.props.selectedFilterData.selectedBadge.forEach(function (item, index) {
                    temp.selectedBadge[index] = {};
                    temp.selectedBadge[index]['id'] = item.id;
                    temp.selectedBadge[index]['value'] = item.value;
                });
            }
        }
        if (this.props.selectedFilterData.selectedLocation != undefined) {
            if (this.props.selectedFilterData.selectedLocation.length > 0) {
                this.props.selectedFilterData.selectedLocation.forEach(function (item, index) {
                    temp.selectedLocation[index] = {};
                    temp.selectedLocation[index]['id'] = item.id;
                    temp.selectedLocation[index]['value'] = item.value;
                });
            }
        }
        if (this.props.selectedFilterData.selectedPublication != undefined) {
            if (this.props.selectedFilterData.selectedPublication.length > 0) {
                this.props.selectedFilterData.selectedPublication.forEach(function (item, index) {
                    temp.selectedPublication[index] = {};
                    temp.selectedPublication[index]['id'] = item.id;
                    temp.selectedPublication[index]['value'] = item.value;
                });
            }
        }
        if (this.props.selectedFilterData.selectedType != undefined) {
            if (this.props.selectedFilterData.selectedType.length > 0) {
                this.props.selectedFilterData.selectedType.forEach(function (item, index) {
                    temp.selectedType[index] = {};
                    temp.selectedType[index]['id'] = item.id;
                    temp.selectedType[index]['value'] = item.value;
                });
            }
        }
        if (this.props.selectedFilterData.selectedVerified != undefined) {
            if (this.props.selectedFilterData.selectedVerified.length > 0) {
                this.props.selectedFilterData.selectedVerified.forEach(function (item, index) {
                    temp.selectedVerified[index] = {};
                    temp.selectedVerified[index]['id'] = item.id;
                    temp.selectedVerified[index]['value'] = item.value;
                });
            }
        }
        if (this.props.selectedFilterData.selectedVerificationStatus != undefined) {
            if (this.props.selectedFilterData.selectedVerificationStatus.length > 0) {
                this.props.selectedFilterData.selectedVerificationStatus.forEach(function (item, index) {
                    temp.selectedVerificationStatus[index] = {};
                    temp.selectedVerificationStatus[index]['id'] = item.id;
                    temp.selectedVerificationStatus[index]['value'] = item.value;
                });
            }
        }

        this.setState({ item: temp });

        industryList()
            .then(res => {
                this.setState({ industryList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        skillList()
            .then(res => {
                this.setState({ skillList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        jobNicheList()
            .then(res => {
                this.setState({ topicList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        badgeList()
            .then(res => {
                this.setState({ badgeList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        scraperList()
            .then(res => {
                this.setState({ scraperList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        countryList()
            .then(res => {
                this.setState({ countryList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    render() {
        return (
            <div className="model-container model-center model-backdrop-show external-user-modal-container">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Apply Filter</h2>
                    <div className="model-content ">
                        <div className="writerFilterContainer">
                            <div className="writerFilterContent">
                                {!this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="industry">Select Industry</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="industry"
                                            id="industry"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleIndustrySelectChange}
                                            options={this.state.industryList}
                                            ref={this.selectIndustryRef}
                                            menuPlacement="auto"
                                        ></Select>
                                    </div>
                                }
                                {this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="industry">Select Industry</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="industry"
                                            id="industry"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleIndustrySelectChange}
                                            options={this.state.industryList}
                                            ref={this.selectIndustryRef}
                                            menuPlacement="auto"
                                            value={this.state.industryList.filter(
                                                item => {
                                                    const temp = this.state.item.selectedIndustry.map(
                                                        item => item.id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                    </div>
                                }

                                {!this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="topic">Select Topic</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="topic"
                                            id="topic"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleTopicSelectChange}
                                            options={this.state.topicList}
                                            ref={this.selectTopicRef}
                                            menuPlacement="auto"
                                        ></Select>
                                    </div>
                                }

                                {this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="topic">Select Topic</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="topic"
                                            id="topic"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleTopicSelectChange}
                                            options={this.state.topicList}
                                            ref={this.selectTopicRef}
                                            menuPlacement="auto"
                                            value={this.state.topicList.filter(
                                                item => {
                                                    const temp = this.state.item.selectedTopic.map(
                                                        item => item.id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                    </div>
                                }


                                {!this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="skill">Select Skill</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="skill"
                                            id="skill"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleSkillSelectChange}
                                            options={this.state.skillList}
                                            ref={this.selectSkillRef}
                                            menuPlacement="auto"
                                        ></Select>
                                    </div>
                                }

                                {this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="skill">Select Skill</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="skill"
                                            id="skill"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleSkillSelectChange}
                                            options={this.state.skillList}
                                            ref={this.selectSkillRef}
                                            menuPlacement="auto"
                                            value={this.state.skillList.filter(
                                                item => {
                                                    const temp = this.state.item.selectedSkill.map(
                                                        item => item.id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                    </div>
                                }


                                {!this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="badge">Select Badge</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="badge"
                                            id="badge"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleBadgeSelectChange}
                                            options={this.state.badgeList}
                                            ref={this.selectBadgeRef}
                                            menuPlacement="auto"
                                        ></Select>
                                    </div>
                                }

                                {this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="badge">Select Badge</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="badge"
                                            id="badge"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleBadgeSelectChange}
                                            options={this.state.badgeList}
                                            ref={this.selectBadgeRef}
                                            menuPlacement="auto"
                                            value={this.state.badgeList.filter(
                                                item => {
                                                    const temp = this.state.item.selectedBadge.map(
                                                        item => item.id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                    </div>
                                }

                                {!this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="location">Select Location</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="location"
                                            id="location"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleLocationSelectChange}
                                            options={this.state.countryList}
                                            menuPlacement="top"
                                            ref={this.selectLocationRef}
                                            maxMenuHeight={140}
                                        ></Select>
                                    </div>
                                }

                                {this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="location">Select Location</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="location"
                                            id="location"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleLocationSelectChange}
                                            options={this.state.countryList}
                                            menuPlacement="top"
                                            ref={this.selectLocationRef}
                                            maxMenuHeight={140}
                                            value={this.state.countryList.filter(
                                                item => {
                                                    const temp = this.state.item.selectedLocation.map(
                                                        item => item.id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                    </div>
                                }

                                {!this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="publication">Select Publication</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="publication"
                                            id="publication"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handlePublicationSelectChange}
                                            options={this.state.scraperList}
                                            menuPlacement="top"
                                            ref={this.selectPublicationRef}
                                            maxMenuHeight={150}
                                        ></Select>
                                    </div>
                                }

                                {this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="publication">Select Publication</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="publication"
                                            id="publication"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handlePublicationSelectChange}
                                            options={this.state.scraperList}
                                            menuPlacement="top"
                                            ref={this.selectPublicationRef}
                                            maxMenuHeight={150}
                                            value={this.state.scraperList.filter(
                                                item => {
                                                    const temp = this.state.item.selectedPublication.map(
                                                        item => item.id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                    </div>
                                }

                                {!this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="type">Select Type</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="type"
                                            id="type"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleTypeSelectChange}
                                            options={this.state.typeList}
                                            ref={this.selectTypeRef}
                                            menuPlacement="top"
                                        ></Select>
                                    </div>
                                }

                                {this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="type">Select Type</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="type"
                                            id="type"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleTypeSelectChange}
                                            options={this.state.typeList}
                                            ref={this.selectTypeRef}
                                            menuPlacement="top"
                                            value={this.state.typeList.filter(
                                                item => {
                                                    const temp = this.state.item.selectedType.map(
                                                        item => item.id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                    </div>
                                }

                                {!this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="verified">Verified?</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="verified"
                                            id="verified"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleVerifiedSelectChange}
                                            options={this.state.verifiedList}
                                            ref={this.selectVerifiedStatusRef}
                                            menuPlacement="top"
                                        ></Select>
                                    </div>
                                }

                                {this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="verified">Verified?</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="verified"
                                            id="verified"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleVerifiedSelectChange}
                                            options={this.state.verifiedList}
                                            ref={this.selectVerifiedStatusRef}
                                            menuPlacement="top"
                                            value={this.state.verifiedList.filter(
                                                item => {
                                                    const temp = this.state.item.selectedVerified.map(
                                                        item => item.id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                    </div>
                                }

                                {!this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="verification_status">Select Verification Status</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                            }}
                                            name="verification_status"
                                            id="verification_status"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleVerificationStatusSelectChange}
                                            options={this.state.verifiationStatusList}
                                            ref={this.selectVerifcationStatusRef}
                                            menuPlacement="top"
                                        ></Select>
                                    </div>
                                }

                                {this.props.isFilterApplied &&
                                    <div className="form-group">
                                        <label htmlFor="verification_status">Select Verification Status</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                            }}
                                            name="verification_status"
                                            id="verification_status"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={this.handleVerificationStatusSelectChange}
                                            options={this.state.verifiationStatusList}
                                            ref={this.selectVerifcationStatusRef}
                                            menuPlacement="top"
                                            value={this.state.verifiationStatusList.filter(
                                                item => {
                                                    const temp = this.state.item.selectedVerificationStatus.map(
                                                        item => item.id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="form-group writerFilterFooter">
                            <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={this.state.loading}
                                onClick={this.applyFilter}
                            >
                                {this.state.loading ? `Processing...` : `Apply Filter`}
                                <i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : ``}></i>
                            </button>
                            <button
                                type="button"
                                className="btn clear-filter-button mr-2"
                                disabled={this.state.loading}
                                onClick ={this.clearFilter}
                            >
                                {this.state.clearFilterloading ? `Processing...` : `Clear Filter`}
                                <i className={this.state.clearFilterloading ? `mr-2 fas fa-spinner fa-spin` : ``}></i>
                            </button>
                            <button
                                type="button"
                                onClick={this.props.hideFilter}
                                className="btn btn-default"
                                disabled={this.state.loading}
                            >
                                Close Modal
                            </button>
                        </div>
                    </div>
                        
                </div>
            </div>
        )
    }
}

FilterModel.contextType = AppContext;
export default FilterModel;


// WEBPACK FOOTER //
// ./src/components/admin/writers/FilterModel.js